<template>
  <div class="boox-list-page">
    <div class="global-header-wrap">
      <div class="left-part">
        <span>{{ $t("router.serverMGT") }}</span>
      </div>
      <div class="right-part">
        <button
          class="global-button-style"
          @click="$router.push({ name: 'serverAdd' })"
        >
          <img src="@/assets/img/cmb_btn_add.png" />{{ $t("commonMsg.new") }}
        </button>
      </div>
    </div>
    <el-card
      class="app-table-container serverMGT-card"
      :body-style="{ padding: '20px' }"
    >
      <div slot="header" class="serverListHeader">
        <div class="serverListHeader-left">
          <TabHeader
            :slideData="slideData"
            :tab="tab"
            @headerTabBack="headerTabBack"
          ></TabHeader>
        </div>
        <div class="serverListHeader-right">
          <button class="global-button-style" @click="syncCnData">
            一键同步国服数据
          </button>
        </div>
      </div>
      <div class="global-body-wrap" ref="wrap">
        <el-table
          ref="table"
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :height="tableHeight"
          @filter-change="filterTag"
          style="width: 100%; height: 100%; overflow-y: scroll"
        >
          <el-table-column
            type="index"
            align="center"
            fixed="left"
            label="序号"
            :key="Math.random()"
            width="50"
          >
            <template slot-scope="scope">
              <span>{{
                (params.page - 1) * params.limit + scope.$index + 1
              }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="name" align="center" label="默认名字">
          </el-table-column>
          <el-table-column prop="lang" align="center" label="语言">
          </el-table-column>
          <el-table-column
            prop="host"
            align="center"
            show-overflow-tooltip
            label="域名"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.host">{{
                JSON.stringify(scope.row.host).substring(
                  1,
                  JSON.stringify(scope.row.host).length - 1
                )
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="ossConfig"
            align="center"
            show-overflow-tooltip
            label="oss"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.ossConfig">{{
                JSON.stringify(scope.row.ossConfig).substring(
                  1,
                  JSON.stringify(scope.row.ossConfig).length - 1
                )
              }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="langGroup"
            align="center"
            show-overflow-tooltip
            label="多语言"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.langGroup">{{
                JSON.stringify(scope.row.langGroup).substring(
                  1,
                  JSON.stringify(scope.row.langGroup).length - 1
                )
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="region" align="center" label="区域">
          </el-table-column>
          <el-table-column
            prop="disable"
            align="center"
            show-overflow-tooltip
            column-key="tableDisable"
            :filter-multiple="false"
            label="是否禁用"
            :filters="[
              { text: '禁用', value: 'yes' },
              { text: '开放', value: 'no' },
              { text: '内测', value: 'test' },
            ]"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.disable !== 'test'">{{
                scope.row.disable === "yes" ? "禁用" : "开放"
              }}</span>
              <span v-else>内测</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="updatedAt"
            align="center"
            show-overflow-tooltip
            label="日期"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.updatedAt | filterDate }}</span>
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="管理" align="center">
            <template slot-scope="scope">
              <!--<span @click="toView(scope.row._id)" class="checkDetailsBtn">查看详情</span>-->
              <span @click="toEdit(scope.row._id)" class="checkDetailsBtn"
                >编辑</span
              >
              <span @click="toDel(scope.row._id)" class="delBtn">删除</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <Pagination :pageSize="params.limit" :total="total" @pageNum="pageNum" />
    </el-card>

    <DelPopup @deleteHandle="deleteHandle" v-if="delPopup" />
  </div>
</template>

<script>
import TabHeader from "@/components/tabHeader"
import DelPopup from "@/components/delPopup"
import Pagination from "@/components/pagination"
export default {
  components: {
    TabHeader,
    DelPopup,
    Pagination,
  },
  computed: {
    delPopup: {
      get: function () {
        return this.$store.state.popup.delPopup
      },
      set: function (newValue) {
        this.$store.state.popup.delPopup = newValue
        this.$store.state.popup.appModal = newValue
      },
    },
    tableHeight() {
      return window.innerHeight - 250
    },
    slideData() {
      const slideData = [
        {
          name: "v1",
          component: "v1",
        },
        {
          name: "v2",
          component: "v2",
        },
        {
          name: "v3",
          component: "v3",
        },
      ]
      return slideData
    },
  },
  watch: {},
  data() {
    return {
      tableData: [],
      total: 0,
      params: { limit: 20, page: 1, sortBy: "createdAt", apiVersion: "v1" },
      booxItem: null,
      centerDialogVisible: false,
      serverId: "",
      tab: "v1",
    }
  },
  created() {
    this.getList()
  },
  methods: {
    async syncCnData() {
      try {
        await this.$http.syncCnData()
        this.elMsg("同步成功", "success")
      } catch (error) {
        this.elMsg("同步失败", "error")
      }
    },
    headerTabBack(tab) {
      this.tab = tab.component
      this.$refs.table.clearFilter()
      delete this.params.disable
      this.params.apiVersion = this.tab
      this.$router.push({ name: "serverList", query: { tab: this.tab } })
      this.getList()
    },

    filterTag(obj) {
      if (obj.tableDisable.length) {
        this.params.disable = obj.tableDisable[0]
      } else {
        delete this.params.disable
      }
      this.getList()
    },
    // 表格操作按钮
    tableHandle(type) {
      if (type === "del") {
        this.$http.delServer(this.serverId).then((res) => {
          this.serverId = ""
          this.delPopup = false
          this.elMsg(this.$t("alertMsg.delSuccess"), "success")
          this.getList()
        })
      }
    },
    //  确认删除
    deleteHandle() {
      this.$store.commit("windowHandle", "delPopup")
      this.tableHandle("del")
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f7f7f7;font-weight: 500;"
      }
    },
    getList() {
      this.$http.getServerInfos(this.params).then((res) => {
        this.tableData = res.data.results
        this.total = res.data.count
      })
    },
    toEdit(id) {
      this.$router.push({ name: "serverAdd", query: { id: id } })
    },
    toDel(id) {
      this.serverId = id
      this.delPopup = true
    },
    toView(id) {
      this.$router.push({ name: "updateView", query: { id: id } })
    },
    pageNum(page) {
      this.params.page = page
      this.getList()
    },
  },
  mounted() {
    if (this.$route.query.tab) {
      this.tab = this.$route.query.tab
      this.params.apiVersion = this.tab
    }
  },
}
</script>

<style lang="scss">
.boox-list-page {
  height: 100%;
  display: flex;
  flex-direction: column;
  .left-part {
    flex: 1;
    display: flex;
    align-items: center;
    > span {
      margin-right: 10px;
      font-size: 16px;
    }
    .global-button-style {
      margin: 0;
    }
  }
  .boox-dialog-item {
    padding-bottom: 10px;
    line-height: 25px;
    > p:first-child {
      font-weight: bold;
    }
  }
  .green {
    color: #28c328;
  }
  .serverMGT-card {
    > .el-card__header {
      padding: 0;
      > .serverListHeader {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .serverListHeader-left {
          display: flex;
          align-items: center;
          > p {
            cursor: pointer;
            margin-right: 20px;
          }
        }
        .serverListHeader-right {
          flex: 1;
          display: flex;
          justify-content: flex-end;
          padding: 0 20px;
        }
      }
    }
  }
}
</style>
